export const INACTIVE_TAX_AREA_STRING = "INACTIVE TAX AREA";

export const TableLabels = {
  AMOUNT_REVIEWED: "Amount reviewed",
  AMOUNT_IN_ERROR: "Amount in error",
  ERROR_RATE: "Error rate",
  AMOUNT_ASSESSED: "Amount assessed",
} as const;

export const LabelPopovers = {
  AMOUNT_REVIEWED:
    "The total population (ie: sales, purchases) under review for this tax area.",
  AMOUNT_IN_ERROR:
    "The subpopulation that was determined to have taxation errors for this tax area.",
  ERROR_RATE:
    "The percentage of the population with taxation errors. Error rate = Amt in Error / Amt Reviewed.",
  AMOUNT_ASSESSED:
    "The total tax payment assessed for this tax area. Do not include penalty, interest, or other amounts here.",
} as const;
